module.exports = __webpack_public_path__ + "common/icon_minus-cff727d6acff0798a6eaf1b4e228e487.svg";